interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({ icon = 'ri-inbox-line', title, description, actionLabel, onAction }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6 bg-background-50 border border-dashed border-background-300 rounded-lg">
      <span className="w-16 h-16 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center mb-4">
        <i className={`${icon} text-3xl`} />
      </span>
      <h3 className="text-lg font-bold text-foreground-900">{title}</h3>
      {description && <p className="mt-2 text-sm text-foreground-500 max-w-md leading-relaxed">{description}</p>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 inline-flex items-center gap-1.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-label font-bold px-4 py-2 whitespace-nowrap transition-colors cursor-pointer"
        >
          <i className="ri-refresh-line" />
          {actionLabel}
        </button>
      )}
    </div>
  );
}